import React from "react";

import InfoTooltip from "components/InfoTooltip";

interface PayrollEmployerGroupProps {
  employerGroup?: { id: string; name?: string | null } | null;
}

const PayrollEmployerGroup = ({ employerGroup }: PayrollEmployerGroupProps) => {
  if (!employerGroup) {
    return null;
  }

  return (
    <>
      {employerGroup.name}{" "}
      <InfoTooltip
        tooltipBody={`Group ID: ${employerGroup.id} (click to copy)`}
        copyText={employerGroup.id}
        copyLabel="Group ID"
      />
    </>
  );
};

export default PayrollEmployerGroup;
